import {
  IFaqItemData,
  IFaqItem,
  FAQ_QUESTION_MAX_LENGTH,
  FAQ_ANSWER_MAX_LENGTH
} from './index'

export class FaqItem implements IFaqItem {
  readonly id: number
  question?: string
  answer?: string

  constructor(data?: IFaqItemData) {
    this.update(data)
    this.id = data?.id || 0
  }

  validate(): boolean {
    return this.validateQuestion() && this.validateAnswer()
  }

  validateQuestion(): boolean {
    let question = this.question
    return !!question && question.length <= FAQ_QUESTION_MAX_LENGTH
  }

  validateAnswer(): boolean {
    let answer = this.answer
    return !!answer && answer.length <= FAQ_ANSWER_MAX_LENGTH
  }

  update(data?: IFaqItemData): void {
    this.question = data?.question
    this.answer = data?.answer
  }

}
